import { useState,useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import { Box, Button, Divider, FormControl, InputAdornment,  MenuItem, Select, TextField } from "@mui/material";
import { DateRange, ArrowDropDown, Info } from "@mui/icons-material";
import SelectGroupWrapper from "./group-selection";
import DatePickerWrapper from "./DatePicker";
import TimePickerWrapper from "./TimePicker";
import TextfieldWrapper from "./TextField";
import ApiClient from "helpers/ApiClient";
import { getToken } from "helpers/Tokens";
import { v4 as uuidv4 } from 'uuid';

import "../../find-parking-near-me/components/book-new-session-form/bookanewsession.scss";



interface bookAppointmentForm {
  serviceName: any;
  setServiceName: any;
  setBookingService: any;
  selectedCard: any;
  setToggleSnackbar: any;
  setOpenFeedbackPopup: any;
  servicesFeedback: any;
}

const BookAppointmentForm = (props: bookAppointmentForm) => {
  const { serviceName, setServiceName, setBookingService, selectedCard,  setOpenFeedbackPopup, servicesFeedback } = props;
  const [pcnInfo, setPcnInfo] = useState<any>([]);
  const [selectVehicle,setSelectVehicle]= useState<any>([])
  const [selectedRecord,setSelectedRecord]= useState('')
  const [selectService,setSelectService]=useState('')

  let userData = getToken();

  const getSelectedVehicles = async()=>{
    const response = await ApiClient.get(`vehicle?limit=100&verified=true&userId=${userData?.id}`);
    setSelectVehicle(response?.data?.data);
  }
  const [endTimeError, setEndTimeError] = useState(false)
  const lawyers = serviceName === "Lawyers";
  const INITIAL_FORM_STATE = {
    
    startTime: "",
    endTime: "",
    startDate: "",
    endDate: "",
    attendees: serviceName || null,
    location: "",
    description: "",
    ...(lawyers && {
      title: "",
      appealNumber: "",
      pcnNumber: "",
      pcnDate: "",
      vehicleNumber: "",
      offenseType: "",
      pcnLocation: "",
    }),
    ...(!lawyers && {
    selectVehicle: selectedRecord|| "",
    serviceType: selectService||""
   })
  };
  const FORM_VALIDATION = Yup.object().shape({
   
    startTime: Yup.string().required("Required Field"),
    endTime: Yup.string().required("Required Field"),
    startDate: Yup.date().nullable().typeError("Required Field").required("Required Field"),
    endDate: Yup.date()
      .nullable()
      .when("startDate", (startDate, Yup) => startDate && Yup.min(startDate, "End Date should be greater than Start Date"))
      .required("Required Field")
      .typeError("Enter a value End date"),
    
    description: Yup.string().required("Required Field").trim(),
    ...!lawyers && {
      selectVehicle: Yup.string().required("Required Field"),
    serviceType: Yup.string().required("Required Field"),
    },
    ...lawyers && {
      pcnNumber: Yup.string().required("Required Field"),
      location: Yup.string().required("Required Field").trim(),
      title: Yup.string().required("Required Field").trim(),
    },
  });

  useEffect(() => {
    getSelectedVehicles()
  }, [])

  const serviceTypeData=[
    {serviceTypes:'Registration Plates'},
    {serviceTypes:'Wipers and Washer Bottle'},
    {serviceTypes:'Steering and suspension'},
    {serviceTypes:'Horn Windscreen'},
    {serviceTypes:'Bodywork'},
    {serviceTypes:'Seats & Seat belts'},
    {serviceTypes:'Fuel system'},
    {serviceTypes:'Wheels and tyres'},
    {serviceTypes:'Brakes'},
  ]
  
  return (
    <>
      <Box className="bookSessionSection border-radius-8">
        <h3 className="bookSessionHeading fs-20 fw-700 grey-color">Book Appointment</h3>

        <Formik
          enableReinitialize={true}
          initialValues={{ ...INITIAL_FORM_STATE }}
          validationSchema={FORM_VALIDATION}
          onSubmit={(values) => {
            let startDateTime = dayjs(values.startDate).format('YYYY-MM-DD')+dayjs(values.startTime).format('HH:mm:ss')
            let endDateTime = dayjs(values.endDate).format('YYYY-MM-DD')+dayjs(values.endTime).format('HH:mm:ss')
              const params = {
                title: values.title,
                start: dayjs(startDateTime).format("YYYY-MM-DDTHH:mm:ss"),
                end: dayjs(endDateTime).format("YYYY-MM-DDTHH:mm:ss"),
                location: values.location,
                description: values.description,
                userId: userData.id,
                lawyerId: serviceName === "Lawyers" && selectedCard?._id,
                pcnId: values.pcnNumber,
                eventType: "meeting",
                status: "pending",
              };
  
              if(lawyers){
                ApiClient.post("calendar/book-event", params)
                  .then((res) => {
                    props.setToggleSnackbar({ message: "Meeting scheduled successfully", isToggle: true, mode: "success" });
                    setBookingService("");
                    setOpenFeedbackPopup(true);
                    servicesFeedback(selectedCard?._id);
                    try {
                      ApiClient.put("appeal/assign-lawyer", { lawyerId: selectedCard?._id, pcnId: pcnInfo.id });
                    } catch (error: any) {
                      props.setToggleSnackbar({ message: error?.response?.data?.message, isToggle: true, mode: "error" });
                    }
                  })
                  .catch((error) => {
                    props.setToggleSnackbar({ message: error?.response?.data?.message, isToggle: true, mode: "error" });
                  });
              }else{              
                const paramValues ={
                  title: values.title,
                  vehicleId: values.selectVehicle ,
                  service: values.serviceType,
                  startDate: dayjs(values.startDate).format('YYYY-MM-DD'),
                  startTime: dayjs(values.startTime).format('HH:MM'),
                  endDate:dayjs(values.endDate).format('YYYY-MM-DD'),
                  endTime: dayjs(values.endTime).format('HH:MM'),
                  attendees: serviceName || null,
                  description: values.description,
                  ownerId: selectedCard?.userId,
                }
                
              ApiClient.post("/manage-services/book-appointment",paramValues).then(()=>{
                props.setToggleSnackbar({ message: "Booked successfully", isToggle: true, mode: "success" });
                setBookingService("");
                setOpenFeedbackPopup(true)
                servicesFeedback(selectedCard?.userId)
              }).catch((error)=>{
                props.setToggleSnackbar({ message: error?.response?.data?.message, isToggle: true, mode: "error" });
              })
              }
          }}
        >
          {formik=>(<Form className="form">
            {!lawyers && (
              <>
                <FormControl fullWidth sx={{mb:2}}>
                  <label className={(formik.errors.selectVehicle && formik.touched.selectVehicle)?'error-color':"label-color"}>Select Vehicle <span style={{color:'red'}}>*</span></label>
                  <Select
                   name="selectVehicle"
                  value={formik.values.selectVehicle}
                  error={!!(formik.errors.selectVehicle && formik.touched.selectVehicle)}
                  onChange={(e:any)=>{setSelectedRecord(e.target.value)}}
                  IconComponent={() => <>
                  {formik.errors.selectVehicle && formik.touched.selectVehicle ? <Info sx={{ color: "#DC3545", mr: "13px" }} fontSize="medium" /> : <ArrowDropDown sx={{ color: "#6C6B6B", mr: "13px" }} />}</>}>
                  {selectVehicle?.map((item:any) => 
                    <MenuItem key={uuidv4()} value={item.id}>
                      {item.vehicleNumber}
                    </MenuItem>
                    )}
                  </Select>
                </FormControl>

                <FormControl fullWidth>
                  <label className={(formik.errors.serviceType && formik.touched.serviceType)?'error-color':"label-color"}>Select Type <span style={{color:'red'}}>*</span></label>
                  <Select
                   name="serviceType"
                   value={formik.values.serviceType}
                   error={!!(formik.errors.serviceType && formik.touched.serviceType)}
                   onChange={(e:any)=>{setSelectService(e.target.value)}}
                   IconComponent={() => <>
                    {formik.errors.serviceType && formik.touched.serviceType ? <Info sx={{ color: "#DC3545", mr: "13px" }} fontSize="medium" /> : <ArrowDropDown sx={{ color: "#6C6B6B", mr: "13px" }}/>}
                   </>}
                   >
                  {serviceTypeData?.map((item) => 
                    <MenuItem key={uuidv4()} value={item.serviceTypes}>
                      {item.serviceTypes}
                    </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </>
            )}
            

            {lawyers && <TextfieldWrapper className="addVechileFields" name="title" inputLabel="Add Title" />}
            <Box className="stylingalighnmentonparklater">
              <Box className="order-2 timePicker">
                <TimePickerWrapper className="timePicker" name="startTime" inputLabel="Start Time" placeholder="Choose a time" />
              </Box>
              <Box className="order-4 endTime">
                <TimePickerWrapper className="timePicker" endTimeError={endTimeError} name="endTime" inputLabel="End Time" placeholder="Choose a time" />
              </Box>
              <>
                <Box className="order-1 timePicker">
                  <DatePickerWrapper className="timePicker" name="startDate" inputLabel="Start Date" placeholder="DD/MM/YYYY" />
                </Box>
                <Box className="order-3 timePicker endDate">
                  <DatePickerWrapper className="timePicker" name="endDate" inputLabel="End Date" placeholder="DD/MM/YYYY" />
                </Box>
              </>
            </Box>
            <TextfieldWrapper className="addVechileFields" name="attendees" inputLabel="Attendees" />
            {lawyers && <TextfieldWrapper className="addVechileFields" name="location" inputLabel="Add Location" />}
            <TextfieldWrapper className="addVechileFields" name="description" inputLabel="Description" />

            {lawyers && (
              <>
                <Box sx={{ mt: 2 }}>
                  <h3 className=" fs-20 fw-700 grey-color">PCN Information</h3>
                </Box>
                <Divider />

                <SelectGroupWrapper className="pcnNumber" name="pcnNumber" label="PCN Number" setPcnInfo={setPcnInfo} />

                <Box sx={{ mt: 2 }}>
                  <label>
                    PCN Date <span style={{ color: "red" }}>*</span>
                  </label>
                  <TextField
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#152536",
                        background: "#EBEEF1",
                      },
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">{<DateRange fontSize="medium" />}</InputAdornment>,
                    }}
                    value={pcnInfo?.issuedAt ? dayjs(pcnInfo.issuedAt).format("DD/MM/YYYY") : ""}
                    className="pcnDate"
                    disabled
                    fullWidth
                    name="pcnDate"
                  />
                </Box>

                <Box sx={{ mt: 2 }}>
                  <label>
                    Location <span style={{ color: "red" }}>*</span>
                  </label>
                  <TextField
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#152536",
                        background: "#EBEEF1",
                      },
                    }}
                    className="pcnLocation"
                    disabled
                    fullWidth
                    name="pcnLocation"
                    value={pcnInfo?.location}
                  />
                </Box>

                <Box sx={{ mt: 2 }}>
                  <label>
                    Vehicle Number <span style={{ color: "red" }}>*</span>
                  </label>
                  <TextField
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#152536",
                        background: "#EBEEF1",
                      },
                    }}
                    className="vehicleNumber"
                    disabled
                    fullWidth
                    name="vehicleNumber"
                    value={pcnInfo?.vehicleNumber}
                  />
                </Box>

                <Box sx={{ mt: 2 }}>
                  <label>
                    Offense Type <span style={{ color: "red" }}>*</span>
                  </label>
                  <TextField
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#152536",
                        background: "#EBEEF1",
                      },
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">{<ArrowDropDown fontSize="medium" />}</InputAdornment>,
                    }}
                    className="offenseType"
                    disabled
                    fullWidth
                    name="offenseType"
                    value={pcnInfo?.offenceType}
                  />
                </Box>
              </>
            )}

            <Box className="backandProceedButtons ">
              <Button
                onClick={() => {
                  setServiceName(serviceName);
                  setBookingService("");
                }}
                sx={{ color: "black" }}
              >
                Back
              </Button>
              <button className="btn-primary " type="submit">
                {" "}
                Add
              </button>
            </Box>
          </Form>)}
        </Formik>
      </Box>
    </>
  );
};

export default BookAppointmentForm;
